import { useEffect, useRef, useState } from 'react';

import './CalendarCarousel.scss';
import { useMobile } from '../../../helpers/hooks';
import { getString } from '../../../helpers/styles';
import { pregnancyWeekList, babyWeekList } from '../../../helpers/userWeek';
import ChevronLeft from '../../../shared/assets/icons/redesign/chevron-left.svg';
import ChevronRight from '../../../shared/assets/icons/redesign/chevron-right.svg';

export default function CalendarCarousel({ uri }) {
  const listRef = useRef();
  const activeItemRef = useRef();
  const [isMobile] = useMobile();

  const centerItemIndex = 8;
  const activeItemIndex = +activeItemRef.current?.dataset.index;

  const [title, list] = uri.includes('baby-week')
    ? ['Babykalender', babyWeekList]
    : ['Zwangerschapskalender', pregnancyWeekList];

  const [page, setPage] = useState(0);

  useEffect(() => {
    if (isMobile)
      activeItemRef.current.scrollIntoView({ inline: 'center', block: 'end' });
  }, [isMobile]);

  return (
    <div className="calendarCarousel">
      <h5 className="calendarCarousel-title">{title}</h5>

      <div className="calendarCarousel-content">
        <div>
          <ChevronLeft
            onClick={back}
            className={getString([
              {
                value: 'calendarCarousel-btn-back cursor-pointer',
                condition: true
              },
              {
                value: 'calendarCarousel-btn-disabled',
                condition:
                  activeItemIndex >= centerItemIndex
                    ? activeItemIndex + page < centerItemIndex
                    : page === 0
              }
            ])}
          />
        </div>

        <div className="calendarCarousel-list-wrap">
          <ul ref={listRef} className="calendarCarousel-list">
            {list.map(({ number, link, label }, idx) => (
              <li
                {...(uri === link.slice(1) && {
                  ref: activeItemRef,
                  'data-index': idx
                })}
                key={idx}
                {...(!isMobile &&
                  activeItemIndex > centerItemIndex && {
                    style: {
                      transform: `translateX(${
                        (activeItemIndex - centerItemIndex + 1) * -66
                      }px)`
                    }
                  })}
                className={getString([
                  {
                    value: 'calendarCarousel-list-item cursor-pointer',
                    condition: true
                  },
                  {
                    value: 'calendarCarousel-list-item-active',
                    condition: uri === link.slice(1)
                  }
                ])}
                onClick={() => (location.href = link)}
              >
                {number}
                <span>{label.slice(0, 1).toLowerCase()}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <ChevronRight
            onClick={next}
            className={getString([
              {
                value: 'calendarCarousel-btn-next cursor-pointer',
                condition: true
              },
              {
                value: 'calendarCarousel-btn-disabled',
                condition:
                  activeItemIndex >= centerItemIndex
                    ? activeItemIndex + page >= list.length - centerItemIndex
                    : page + centerItemIndex + centerItemIndex > list.length
              }
            ])}
          />
        </div>
      </div>
    </div>
  );

  function back() {
    listRef.current.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${(page - 1) * -66}px);
      transition-property: transform;
    `;

    setPage(page - 1);
  }

  function next() {
    listRef.current.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${(page + 1) * -66}px);
      transition-property: transform;
    `;

    setPage(page + 1);
  }
}
